import { render, staticRenderFns } from "./class_record2.vue?vue&type=template&id=ba0496b6&scoped=true"
import script from "./class_record2.vue?vue&type=script&lang=js"
export * from "./class_record2.vue?vue&type=script&lang=js"
import style0 from "./class_record2.vue?vue&type=style&index=0&id=ba0496b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0496b6",
  null
  
)

export default component.exports